import { ServiceStatusConstant } from '../actions/constants/ServiceStatusConstant';
import { AppConfig } from '../config';
import { routeWebSocketMessage } from './WebSocketMessageRouter';

class WebSocketService {
  constructor() {
    this.ws = null;
    this.dispatch = null;
    this.getState = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 10;
    this.reconnectDelay = 3000; // 3초 기본, exponential backoff
    this.reconnectTimer = null;
  }

  init(dispatch, getState) {
    this.dispatch = dispatch;
    this.getState = getState;
  }

  connect() {
    if (!this.dispatch) return;
    if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
      return;
    }

    const token = localStorage.getItem('userToken');
    if (!token || !AppConfig.WS_SERVER_PATH) return;

    try {
      const wsUrl = `${AppConfig.WS_SERVER_PATH}?token=${token}`;
      this.ws = new WebSocket(wsUrl);

      this.ws.onopen = () => {
        console.log('[WS] Connected');
        this.reconnectAttempts = 0;
        this.dispatch({ type: ServiceStatusConstant.WS_CONNECTED });
      };

      this.ws.onmessage = (event) => {
        const issueManagerIds = this.getState?.()?.ServiceModalReducer?.issueManagerIds || [];
        routeWebSocketMessage(event.data, this.dispatch, { issueManagerIds });
      };

      this.ws.onclose = (event) => {
        console.log('[WS] Disconnected', event.code);
        this.dispatch({ type: ServiceStatusConstant.WS_DISCONNECTED });
        this.ws = null;
        this.scheduleReconnect();
      };

      this.ws.onerror = (error) => {
        console.warn('[WS] Error:', error);
      };
    } catch (err) {
      console.warn('[WS] Connection failed:', err);
    }
  }

  scheduleReconnect() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
    }
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.log('[WS] Max reconnect attempts reached');
      return;
    }
    const delay = this.reconnectDelay * Math.pow(1.5, this.reconnectAttempts);
    console.log(`[WS] Reconnecting in ${Math.round(delay / 1000)}s (attempt ${this.reconnectAttempts + 1})`);
    this.reconnectTimer = setTimeout(() => {
      this.reconnectAttempts++;
      this.connect();
    }, delay);
  }

  disconnect() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }
    this.reconnectAttempts = this.maxReconnectAttempts; // 재연결 방지
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }
}

export default new WebSocketService();
